export default __webpack_public_path__ + "static/media/workforce.c50e027c.svg";